import React from 'react'
import useTranslation from '../../shared/TranslationProvider'
import { useExercise } from '../ExerciseProvider'

const VitalityExerciseSummary = () => {
  const { t } = useTranslation('vitality')
  const { getResponse } = useExercise()
  const rankedPoints = getResponse(0, 'rankedPoints')

  const actionIdea = getResponse(1, 'ideas')

  const topFivePoints = rankedPoints
    .filter((point) => point.rank !== null)
    .sort((a, b) => a.rank - b.rank)
    .slice(0, 5)

  return (
    <div className="flex flex-col md:flex-row md:justify-evenly">
      <div>
        <div className="subtitle">{t('top_5_points_of_vitality')}</div>
        <ol className="list-decimal">
          {topFivePoints.map((point, index) => (
            <li
              key={`top_vitality_point-${index}`}
              className="flex list-decimal items-center gap-2"
            >
              {point.name}
            </li>
          ))}
        </ol>
      </div>
      {actionIdea && (
        <div>
          <div className="subtitle">{t('action_to_take')}</div>
          <div>{actionIdea}</div>
        </div>
      )}
    </div>
  )
}

export default VitalityExerciseSummary
